import { combineReducers, createStore, applyMiddleware, compose } from 'redux'
import { windowDimensionsReducer } from './window-dimensions'
import rootSaga from './sagas'
import createSagaMiddleware from 'redux-saga'
import { rawDataReducer } from './raw-data'
import { pageMapReducer } from './PageMap'
import { mapsContainerReducer } from './MapsContainer'
import { treeMapReducer } from './TreeMap'

const rootReducer = combineReducers({
    windowDimensions: windowDimensionsReducer,
    rawData: rawDataReducer,
    PageMap: pageMapReducer,
    MapsContainer: mapsContainerReducer,
    TreeMap: treeMapReducer,
})

const sagaMiddleware = createSagaMiddleware()

export type RootState = ReturnType<typeof rootReducer>

const enhancers = [applyMiddleware(sagaMiddleware)]
if (
    process.env.NODE_ENV === 'development' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__
) {
    enhancers.push(
        (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
            (window as any).__REDUX_DEVTOOLS_EXTENSION__()
    )
}

const preloadedState = {}

export const store = createStore(
    rootReducer,
    preloadedState,
    compose(...enhancers)
)

sagaMiddleware.run(rootSaga)
